// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getConfigLink, getInfoLink } from '../../../store/pdb';
import ButtonComponent, {
  LinkButton as LinkButtonComponent,
} from '../../button';
import PriceComponent from '../../price';
import type { Theme } from '../../../types';

const LinkButton = styled<typeof LinkButtonComponent, Theme>(LinkButtonComponent)`
  && {
    align-self: center;
  }
`;

const Button = styled<typeof ButtonComponent, Theme>(ButtonComponent)`
  align-self: center;
  margin-bottom: 0;
`;

const Container = styled<any, Theme>('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledPrice = styled<typeof PriceComponent, Theme>(PriceComponent)`
  font-size: 1.75rem;
  color: ${props => props.theme.techSpecs.price.color};
  font-weight: bold;
  margin-bottom: 1.3rem;
`;

type OwnProps = {|
  pdbId: string, // eslint-disable-line react/no-unused-prop-types
  price: number,
  orderLabel: string,
  moreInfoLabel: string,
|};

type StateProps = {|
  configLink: string,
  modelInfoLink: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const Price = ({
  price,
  orderLabel,
  moreInfoLabel,
  modelInfoLink,
  configLink,
}: Props) => (
  <Container>
    <StyledPrice displayCurrencySymbol amount={price} />
    <Button href={configLink}>{orderLabel}</Button>
    <LinkButton href={modelInfoLink || configLink} variant="link">
      {moreInfoLabel}
    </LinkButton>
  </Container>
);

const mapStateToProps = (state: any, { pdbId }: OwnProps): StateProps => ({
  configLink: getConfigLink(state, pdbId),
  modelInfoLink: getInfoLink(state, pdbId),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(Price);
